module.exports = __webpack_public_path__ + "static/img/bg_grow_bag.4f7c5868.png";